<template>
  <div class="print-d" style="margin:auto;">
    <div class="print-div">
      <div class="print-header">
        <div class="center">
          <div class="info">
            <span class="main-name">远景食品配送单</span>
          </div>
        </div>
      </div>
      <div class="print-content">
        <div class="no">
          <div>单据编码: {{data.DocNo}}</div>
          <div>支付方式: {{data.Receipts.length?data.Receipts.map(e=>{return e.SettleName}).join(','):''}}</div>
          <div>开单日期: {{data.DocDate}}</div>
        </div>
        <div class="info">
          <div>客户名称：{{data.CustomerName}}</div>
          <div>联系电话：</div>
          <div>仓库：{{data.WarehouseNames}}</div>
          <div>业务员：{{data.ClerkName}}</div>
        </div>
        <table class="print-table" style="text-align:center;line-height:1.5">
          <tr>
            <th style="width:100px">产品名称</th>
            <th style="width:100px">规格型号</th>
            <th style="width:60px">单位</th>
            <th style="width:60px">数量</th>
            <th style="width:60px">单价</th>
            <th style="width:60px">金额</th>
            <th style="width:60px">备注</th>
          </tr>
          <template v-for="(sdnum,sdIndex) in goods">
            <tr :key="sdIndex">
              <td>{{sdnum.GoodsName}}</td>
              <td>{{sdnum.Model}}</td>
              <td>{{sdnum.UnitName}}</td>
              <td>{{sdnum.Quantity}}</td>
              <td>{{sdnum.Price}}</td>
              <td>{{sdnum.Amount}}</td>
              <td>{{sdnum.Remark}}</td>
            </tr>
          </template>
          <tr>
            <th colspan="7" class="total">
              合计人民币（大写）：
              <span class="cTotal">{{data.cTotal}}</span>
              <span style="float:right;">
                <span>￥：</span>
                <span class="nTotal">{{data.total}}</span>
              </span>
            </th>
          </tr>
        </table>
        <div class="no">
          <div>开单人: 自主下单或代客下单</div>
          <div>送货人:</div>
          <div>客户签收:</div>
        </div>
        <div class="footText">
          <div class="text_left">
            <div>注：请您在收到货物后，依订货单核对下单数量及规格，确认后签字同传送货单，谢谢配合！</div>
            <div
              v-html="'系统默认开单日期为客户下单日期，隔天配送&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;投诉电话：13536860395'"
            ></div>
          </div>

          <div>
            <el-image :src="require('@/assets/qrcode.jpg')" fit="contain"></el-image>
            <el-image :src="require('@/assets/qrcode.jpg')" fit="contain"></el-image>
          </div>
        </div>
      </div>
      <div style="clear:both;"></div>
    </div>
    <div slot="footer" class="handle-button oo-print">
      <el-button icon="el-icon-printer" size="mini" type="primary" @click="print">打印</el-button>
    </div>
  </div>
</template>
<script>
const max = 4;

export default {
  data() {
    return {
      api: require("@/api/sale/saDoc").default,     
      data: {
        SaleDeliveryNumber: "",
        Salesman: "",
        Driver: "",
        SendTime: "",
        Remarks: "",
        Details: [],
      },
      leave: 0,
      nolist: [],
      goods: [],
    };
  },
  beforeMount() {
    var sid = this.$route.query.sid;
    this.api.info(sid).then((res) => {
      res.Data.total = 0;
      res.Data.Goods.forEach((m) => {
        res.Data.total += m.Amount;
      });
      res.Data.cTotal = toPrice(res.Data.total);
      this.data = res.Data;
    });
    this.api.getGoodsList(sid).then((res) => {
      // this.data = res.Data
      res.Data.forEach((item) => {
        this.count(item, true);
      });
      this.goods = res.Data;
      return;
      var dl = [];
      res.Data.forEach((e) => {
        dl.push({
          // line: Math.ceil(e.DetailModel.length/6)+1,
          // num: e.DetailModel.length
        });
      });
      var nolist = [];

      // index显示数据的下标 numlist下标范围 pl剩余未显示下标范围 ll剩余未显示行数(包含表头) e.line包含表头
      // dl.forEach((e,index) => {
      for (var index = 0; index < dl.length; index++) {
        var e = dl[index];
        if (index == 0) {
          if (e.line > max) {
            nolist.push({
              index: [0],
              numlist: [0, (max - 1) * 6 - 1],
              pl: [(max - 1) * 6, e.num - 1],
              ll: countLine((max - 1) * 6, e.num) + 1,
            });
          } else {
            var limit = max - e.line;
            if (dl.length > 1 && limit >= 2) {
              //显示下一个
              if (dl[index + 1].line > limit) {
                //部分显示
                nolist.push({
                  index: [0, 1],
                  numlist: [0, e.num - 1, 0, (limit - 1) * 6 - 1],
                  pl: [(limit - 1) * 6, dl[index + 1].num - 1],
                  ll: countLine((limit - 1) * 6, dl[index + 1].num) + 1,
                  self: true,
                });
              } else {
                //显示全部
                nolist.push({
                  index: [0, 1],
                  numlist: [0, e.num - 1, 0, dl[index + 1].num - 1],
                  pl: [],
                  ll: 1,
                });
                dl.splice(index + 1, 1);
              }
            } else {
              nolist.push({
                index: [0],
                numlist: [0, e.num - 1],
                pl: [],
                ll: 1,
              });
            }
          }
        } else {
          if (nolist[index - 1].ll > 1) {
            // 上一个有剩余
            var limit = max - nolist[index - 1].ll;
            if (nolist[index - 1].self) {
              //剩余的是本身
              if (dl.length <= index + 1) {
                nolist.push({
                  index: [index],
                  numlist: [nolist[index - 1].pl[0], e.num - 1],
                  pl: [],
                  ll: 1,
                });
              } else if (limit >= 2) {
                if (dl[index + 1].line > limit) {
                  nolist.push({
                    index: [index, index + 1],
                    numlist: [
                      nolist[index - 1].pl[0],
                      e.num - 1,
                      0,
                      (limit - 1) * 6 - 1,
                    ],
                    pl: [(limit - 1) * 6, dl[index + 1].num - 1],
                    ll: 1,
                    self: true,
                  });
                } else {
                  nolist.push({
                    index: [index, index + 1],
                    numlist: [
                      nolist[index - 1].pl[0],
                      e.num - 1,
                      0,
                      dl[index + 1].num - 1,
                    ],
                    pl: [],
                    ll: 1,
                  });
                  dl.splice(index + 1, 1);
                }
              } else {
                nolist.push({
                  index: [index],
                  numlist: [nolist[index - 1].pl[0], e.num - 1],
                  pl: [],
                  ll: 1,
                });
              }
            } else {
              if (limit > 2) {
                // 显示本身
                if (limit >= e.line) {
                  // 显示部分本身
                  nolist.push({
                    index: [index - 1, index],
                    numlist: [
                      nolist[index - 1].pl[0],
                      nolist[index - 1].pl[1],
                      0,
                      e.num - 1,
                    ],
                    pl: [],
                    ll: 1,
                  });
                } else {
                  // 完全显示本身
                  nolist.push({
                    index: [index - 1, index],
                    numlist: [
                      nolist[index - 1].pl[0],
                      nolist[index - 1].pl[1],
                      0,
                      (limit - 1) * 6 - 1,
                    ],
                    pl: [(limit - 1) * 6 - 1, e.num - 1],
                    ll: countLine((limit - 1) * 6, e.num) + 1,
                  });
                }
              } else {
                //不显示本身
                nolist.push({
                  index: [index - 1],
                  numlist: [nolist[index - 1].pl[0], nolist[index - 1].pl[1]],
                  pl: [0, e.num - 1],
                  ll: e.line,
                });
                nolist.push({
                  index: [index],
                  numlist: [0, e.num - 1],
                  pl: [],
                  ll: 1,
                });
              }
            }
          } else {
            // 上一个无剩余
            if (e.line > max) {
              // 显示部分本身
              nolist.push({
                index: [index],
                numlist: [0, (max - 1) * 6 - 1],
                pl: [(max - 1) * 6, e.num - 1],
                ll: countLine((max - 1) * 6, e.num) + 1,
              });
            } else {
              // 完全显示本身
              if (index + 1 < dl.length) {
                var limit3 = max - e.line;
                if (limit3 >= 2) {
                  //显示下一个
                  if (dl[index + 1].line <= limit3) {
                    //完全显示下一个
                    nolist.push({
                      index: [index, index + 1],
                      numlist: [0, e.num - 1, 0, dl[index + 1].num - 1],
                      pl: [],
                      ll: 1,
                    });
                    dl.splice(index + 1, 1);
                  } else {
                    //部分显示下一个
                    nolist.push({
                      index: [index, index + 1],
                      numlist: [0, e.num - 1, 0, (limit3 - 1) * 6 - 1],
                      pl: [(limit3 - 1) * 6, dl[index + 1].num - 1],
                      ll: countLine((limit3 - 1) * 6, dl[index + 1].num) + 1,
                      self: true,
                    });
                  }
                } else {
                  //不显示下一个
                  nolist.push({
                    index: [index],
                    numlist: [0, e.num - 1],
                    pl: [],
                    ll: 1,
                  });
                }
              } else {
                //不显示下一个
                nolist.push({
                  index: [index],
                  numlist: [0, e.num - 1],
                  pl: [],
                  ll: 1,
                });
              }
            }
          }
        }
      }
      // })
      nolist.forEach((n) => {
        n.total = 0;
        n.index.forEach((m) => {
          // n.total += this.data.Details[m].QuantityMaterial*this.data.Details[m].PriceMaterial;
        });
        n.cTotal = toPrice(n.total);
      });

      this.nolist = nolist;
    });
  },
  methods: {
    count(row, keep = false) {
      let price = row.Price ? Number(row.Price) : 0;
      let dis = row.Discount ? Number(row.Discount) : 100;
      let qua = row.Quantity ? Number(row.Quantity) : 0;
      let rate = row.TaxRate ? Number(row.TaxRate) : 0;
      let ref = row.ReferenceCost ? Number(row.ReferenceCost) : 0;
      if (row.T !== 0 && !keep) row.T = 1;
      row.Amount = (price * qua - dis / 100).toFixed(2);
      if (row.Amount < 0) row.Amount = 0;
      row.TaxAmount = ((row.Amount * rate) / 100).toFixed(2) || 0;
      row.GrossProfit = (row.Amount - qua * ref).toFixed(2);
    },
    print() {
      window.print();
    },
  },
};
function countLine(start, end) {
  return Math.ceil((end - start) / 6);
}
function toPrice(n) {
  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
    return ""; //判断数据是否大于0
  }

  var unit = "千百拾亿千百拾万千百拾元角分",
    str = "";
  n += "00";

  var indexpoint = n.indexOf("."); // 如果是小数，截取小数点前面的位数

  if (indexpoint >= 0) {
    n = n.substring(0, indexpoint) + n.substr(indexpoint + 1, 2); // 若为小数，截取需要使用的unit单位
  }

  unit = unit.substr(unit.length - n.length); // 若为整数，截取需要使用的unit单位
  for (var i = 0; i < n.length; i++) {
    str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i); //遍历转化为大写的数字
  }

  return str
    .replace(/零(千|百|拾|角)/g, "零")
    .replace(/(零)+/g, "零")
    .replace(/零(万|亿|元)/g, "$1")
    .replace(/(亿)万|壹(拾)/g, "$1$2")
    .replace(/^元零?|零分/g, "")
    .replace(/元$/g, "元整"); // 替换掉数字里面的零字符，得到结果
}
</script>
<style lang="scss">
.print-d {
  width: 1200px;
  padding-top: 10px;
}
.footer {
  padding-left: 25px;
}
.c-print-dialog {
  font-family: "宋体";
}
.print-div {
  width: 1200px;
  margin: auto;
  border: 1px #aaa solid;
  padding: 10px 20px;
  margin-bottom: 20px;
}
.print-header {
  height: 100px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
  justify-content: center;
  .left {
    width: 65px;
    position: relative;
    .logo {
      display: block;
      width: 65px;
    }
    .cname {
      text-align: center;
      width: 65px;
      display: inline-block;
      font-weight: bold;
      font-size: 18px;
      letter-spacing: 3px;
      margin-top: 8px;
    }
  }
  .center {
    height: 100%;
    margin: 0 80px;
    .info {
      line-height: 90px;
      .main-name {
        font-size: 38px;
        text-align: center;
        font-weight: bold;
        letter-spacing: 14px;
        font-family: "微软雅黑";
      }
    }
  }
}
.tip {
  div,
  span {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
  }
  span {
    margin-right: 30px;
  }
}
.total {
  width: 100%;
  text-align: left;
}
.print-content {
  padding-top: 10px;
  .title {
    text-align: center;
    margin-bottom: 5px;
    font-size: 30px;
    letter-spacing: 40px;
  }
  .info {
    display: flex;
    div {
      width: 20%;
      font-weight: bold;
    }
  }
  .no {
    display: flex;
    margin-bottom: 8px;
    div {
      width: 20%;
      font-weight: bold;
    }
  }
  .footText {
    display: flex;
    .text_left {
      flex: 1;
      display: flex;
      flex-direction: column;
      div {
        flex: 1;
      }
    }
    .el-image {
      width: 100px;
    }
  }
}
.print-table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  margin-top: 8px;
  font-size: 18px;
  td,
  th {
    border: 1px solid #000;
    padding: 2px 6px;
    .cTotal {
      display: inline-block;
      letter-spacing: 0.5rem;
    }
    .nTotal {
      padding: 0 10px;
      display: inline-block;
      text-align: right;
      margin-right: 10px;
    }
  }
  tr {
    height: 32px;
  }

  .label {
    white-space: nowrap;
    text-align: center;
  }
}
.print-footer {
  font-size: 18px;
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  div {
    width: 33.3%;
    font-weight: bold;
    margin-top: 5px;
  }
  span {
    font-weight: normal;
  }
}
.handle-button {
  position: fixed;
  top: 20px;
  right: 10%;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
@media print {
  * {
    font-size: 12px;
  }
  body,
  #app {
    overflow: unset !important;
    min-width: 0 !important;
  }
  /deep/ .no-print {
    display: none;
  }
  .print-d {
    width: 100%;
    height: 100%;
    padding: 0px;
  }
  .no-print {
    display: none;
  }
  .el-dialog__body {
    padding: 0 !important;
  }

  .print-div {
    height: 100%;
    border: none;
    .print-header {
      justify-content: center;
      height: 40px;
      .left {
        .logo {
          width: 20px;
        }
        .cname {
          width: 20px;
          font-size: 12px;
          margin-top: 4px;
          letter-spacing: 0;
          white-space: nowrap;
          margin-left: -6px;
        }
      }
      .center {
        margin: 0;
        .info {
          line-height: 30px;
          .main-name {
            letter-spacing: 6px;
            font-size: 24px;
          }
        }
      }
    }
    .tip {
      div {
        font-size: 10px;
        margin-bottom: 0;
        span {
          font-size: 10px;
        }
      }
    }
    .print-content {
      padding-top: 0px !important;
      .title {
        margin-bottom: 0px;
        font-size: 20px;
        letter-spacing: 20px;
      }
      .no {
        margin-bottom: 0;
      }
      .print-table {
        // line-height: 1 !important;
        margin-top: 5px;
        tr {
          height: 20px;
          font-size: 12px;
          td {
            font-size: 12px;
          }
          th {
            font-size: 12px !important;
          }
        }
      }
    }
    .print-footer {
      div {
        height: 20px !important;
        vertical-align: top;
        // margin-top: ;
        padding: 0;
      }
    }
  }
}
</style>